import { useCallback } from 'react';

const IconTab = ({ icon, id, label, selected, onClick }) => {
  const Icon = icon;

  const color = selected ? 'SLIGreen' : 'SLIBlack';

  const handleClick = useCallback(() => {
    if (onClick) onClick(id);
  }, [onClick, id]);

  return (
    <div
      className={`flex flex-col items-center cursor-pointer text-${color}`}
      onClick={handleClick}
    >
      <Icon alt={''} className="w-8 h-8" />
      <span className="text-sm select-none">{label}</span>
    </div>
  );
};

export { IconTab };
